import { render } from "./FoalFormView.vue?vue&type=template&id=60edc9a0"
import script from "./FoalFormView.vue?vue&type=script&lang=js"
export * from "./FoalFormView.vue?vue&type=script&lang=js"

import "./FoalFormView.vue?vue&type=style&index=0&id=60edc9a0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__